import { useInfiniteQuery } from '@tanstack/react-query'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  EReportColumnHeader,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACampaignsReportTableFilters,
  TDOOHCampaignsReportTableFilters,
  TGenericCampaignsReportTableFilters,
  TPPAdvertiserId,
  TSPCampaignsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

type TParams = (
  | TGenericCampaignsReportTableFilters
  | TSPCampaignsReportTableFilters
  | TDACampaignsReportTableFilters
  | TDOOHCampaignsReportTableFilters
) &
  TPPAdvertiserId & {
    enabled?: boolean
    suspense?: boolean
    pageLimit: number
    pageOffset: number
  }

export default function useGetAdvertiserReportingCampaignsTableV3({
  advertiserId,
  retailerId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: TParams) {
  const queryKeyName = `getAdvertiserReportingCampaignsTable_${channelType}_${advertiserId}_${retailerId}`

  return useInfiniteQuery({
    queryKey: [queryKeyName, { start: startDate, end: endDate, channelType }],
    queryFn: ({ pageParam = { pageOffset, pageLimit } }) => {
      return coreAPIV3
        .advertiserReporting()
        .getAdvertiserCampaignsReportTableV3(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          channelType as EParamChannelTypeGlobal,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          pageParam.pageLimit,
          pageParam.pageOffset,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status
        )
    },
    enabled,
    suspense,
    getNextPageParam: (_, allPages) => {
      const currentOffset = allPages.length * pageLimit

      // NB: reporting service does not send us total items available based on filters (not pagination)
      // therefore one way we decide to not call the endpoint is if the returned items is less than the page limit
      return { pageOffset: currentOffset, pageLimit }
    },
  })
}
